import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { Escolaridad } from 'src/app/interfaces/escolaridad';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { EscolaridadService } from 'src/app/services/escolaridad/escolaridad.service';
import { ProfileComponent } from '../profile.component';

@Component({
  selector: 'app-education-candidate',
  templateUrl: './education-candidate.component.html',
  styleUrls: ['./education-candidate.component.scss']
})
export class EducationCandidateComponent implements OnInit {

  usuario: JwtResponse;
  escolaridades: Escolaridad[];
  grado: Escolaridad;
  noPagina: number;
  mostrarEdicion: boolean;
  editarEscolariodad: boolean;
  formEdu: FormGroup;
  mostrarEducacion: boolean;

  constructor(private escolaridadService: EscolaridadService, private modalService: NgbModal, private formBuilder: FormBuilder) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.mostrarEdicion = false;
    this.editarEscolariodad = false;
    this.grado = {} as Escolaridad;
    this.mostrarEducacion = false;
  }

  ngOnInit() {
    this.noPagina = 1;
    this.cargarEscolaridadCandidato();
    this.crearForm();
  }

  crearForm(): void{
    this.formEdu = this.formBuilder.group({
      grado: [null, Validators.required],
      escuela: [null, Validators.required],
      inicio: [null, [Validators.maxLength(4), Validators.pattern(/^([0-9])*$/)]],
      fin: [null, [Validators.maxLength(4), Validators.pattern(/^([0-9])*$/)]],
    });
  }

  async cargarEscolaridadCandidato() {
    try {
      if(this.usuario && this.usuario.user){
        const response = await this.escolaridadService.obtenerEscolaridadPorIdCandidato(this.usuario.user.idUsuario);
        this.escolaridades = response.data;
        if(this.escolaridades.length == 0){
          this.mostrarEdicion = true;
        } 
      }
    } catch (error) {
      console.error("Error al obtener las escolaridades del candidato", error);
    }
  }

  validarEscolaridad(): void {
    if(this.grado && this.grado.idEscolaridad){
      this.actualizarEscolaridad();
    }else{
      if(this.formEdu.valid){
        this.registrarEscolaridad();
      }
    }
  }

  registrarEscolaridad(): void {
    const escolaridad: Escolaridad = {
      idEscolaridad: null,
      titulo: this.formEdu.get('grado').value,
      institucion: this.formEdu.get('escuela').value,
      anioInicio: this.formEdu.get('inicio').value,
      anioFin: this.formEdu.get('fin').value
    };

    this.escolaridadService.registrarEscolaridad(this.usuario.user.idUsuario, escolaridad).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar la escolaridad del candidato: ', result.messageError);
      }
    });
  }

  actualizarEscolaridad(): void {
    const escolaridad: Escolaridad = {
      idEscolaridad: this.grado.idEscolaridad,
      titulo: this.formEdu.get('grado').value || this.grado.titulo,
      institucion: this.formEdu.get('escuela').value || this.grado.institucion,
      anioInicio: this.formEdu.get('inicio').value || this.grado.anioInicio,
      anioFin: this.formEdu.get('fin').value || this.grado.anioFin
    };

    this.escolaridadService.actualizarEscolaridad(escolaridad).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.grado = {} as Escolaridad;
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error: no se ha actualizo correctamente ', result.messageError);
      }
    });
  }

  eliminarEscolaridadPorId(idEscolaridad: number){
    if(this.usuario.user.idUsuario && idEscolaridad){
      this.escolaridadService.eliminarEscolaridadPorId(this.usuario.user.idUsuario, idEscolaridad).pipe(
        catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })
      ).subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mostrarEdicion = false;
          this.abrirModalMessage("Éxito", "Se ha elimado correctamente.");
        } else {
          this.abrirModalMessage("Error", "No se ha eliminado correctamente " + result.messageError);
          console.error('Error al eliminar la escolaridad del candidato: ', result.messageError);
        }
      });
    }
  }

  habilitarEdicion(escolaridad: Escolaridad): void{
    this.grado = {} as Escolaridad;
    if(escolaridad){
      this.mostrarEdicion = true;
      this.editarEscolariodad = true;
      this.grado = escolaridad;
      this.crearForm();
    }
  }

  mostrarEdicionEducacion(): void {
    this.mostrarEdicion = true;
    this.editarEscolariodad = false;
    this.grado = {} as Escolaridad;
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  mostrarEducacionData(): void {
    this.mostrarEducacion = !this.mostrarEducacion;
  }

  cerrarEducacionData(): void {
    this.mostrarEducacion = false;
  }
}
